// frontend/src/pages/Partners/PartnerNew.jsx
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { createPartner } from '../../api/partner.api.js';
import { PageHeader, FormField, ErrorMessage } from '../../components/ui';
import { ChevronLeft } from 'lucide-react';

export default function PartnerNew() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: '', companyName: '', picName: '', picPhone: '', npwp: '', address: '',
  });
  const [error, setError] = useState(null);

  const create = useMutation({
    mutationFn: createPartner,
    onSuccess:  (data) => navigate(`/partners/${data.id}`),
    onError:    (err)  => setError(err),
  });

  function set(field) { return (e) => setForm((f) => ({ ...f, [field]: e.target.value })); }

  function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    create.mutate(form);
  }

  return (
    <div>
      <Link to="/partners" className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-4">
        <ChevronLeft size={15} /> Back to partners
      </Link>

      <PageHeader
        title="New Partner"
        subtitle="Login credentials will be emailed to the partner automatically."
      />

      <div className="card p-6 max-w-xl">
        <form onSubmit={handleSubmit} className="space-y-4">
          <FormField label="Company Name" required>
            <input className="input" value={form.companyName} onChange={set('companyName')} required />
          </FormField>

          <div className="grid grid-cols-2 gap-3">
            <FormField label="PIC Name" required>
              <input className="input" value={form.picName} onChange={set('picName')} required />
            </FormField>
            <FormField label="PIC Phone">
              <input className="input" type="tel" value={form.picPhone} onChange={set('picPhone')} />
            </FormField>
          </div>

          <FormField label="Email" required>
            <input className="input" type="email" value={form.email} onChange={set('email')} required />
          </FormField>

          <div className="grid grid-cols-2 gap-3">
            <FormField label="NPWP">
              <input className="input" value={form.npwp} onChange={set('npwp')} />
            </FormField>
            <FormField label="Address">
              <input className="input" value={form.address} onChange={set('address')} />
            </FormField>
          </div>

          {error && <ErrorMessage error={error} />}

          <div className="flex gap-3 pt-2">
            <button type="submit" disabled={create.isPending} className="btn-primary">
              {create.isPending ? 'Creating...' : 'Create Partner'}
            </button>
            <Link to="/partners" className="btn-secondary">Cancel</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
